import {
  faCircleCheck,
  faCircleInfo,
  faDotCircle,
  faHourglassStart,
  faSquareParking,
  faTriangleExclamation,
  faUser,
  faUserSlash
} from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconButton, Tooltip } from "@mui/material"
import theme from "css/theme/light"
import { FC } from "react"
import { CustomToolTipInfoProps, TooltipInfoEnum, TooltipInfoIconProps } from "./tooltipInfo.interface"
import styled from "@emotion/styled"
import { useTranslation } from "react-i18next"

const TooltipInfoIcon: FC<TooltipInfoIconProps> = ({ type, iconSize, custom }) => {
  const { t } = useTranslation()
  const { icon, label, color } = custom
    ? custom
    : ({ icon: faDotCircle, label: "", color: "primary" } as CustomToolTipInfoProps)

  const StyledIconButton = styled(IconButton)({
    padding: "0px",
  })


  switch (type) {
    case TooltipInfoEnum.Passed:
      return (
        <Tooltip title={label ? label : t("global.approved", "Approved")}>
          <StyledIconButton color="success" size="small">
            <FontAwesomeIcon
              size={iconSize ? iconSize : "1x"}
              icon={faCircleCheck}
              color={theme.palette["success"].main}
            />
          </StyledIconButton>
        </Tooltip>
      )
    case TooltipInfoEnum.Error:
      return (
        <Tooltip title={label ? label : t("vehicleregistry.driving_ban", "Driving Ban")}>
          <StyledIconButton color="error" size="small">
            <FontAwesomeIcon
              size={iconSize ? iconSize : "1x"}
              icon={faTriangleExclamation}
              color={theme.palette["error"].main}
            />
          </StyledIconButton>
        </Tooltip>
      )
    case TooltipInfoEnum.Failed:
      return (
        <Tooltip title={label ? label : t("global.failed", "Failed")}>
          <StyledIconButton color="error" size="small">
            <FontAwesomeIcon
              size={iconSize ? iconSize : "1x"}
              icon={faTriangleExclamation}
              color={theme.palette["error"].main}
            />
          </StyledIconButton>
        </Tooltip>
      )
    case TooltipInfoEnum.Warning:
      return (
        <Tooltip title={label ? label : t("global.delayed", "Delayed")}>
          <StyledIconButton color="warning" size="small">
            <FontAwesomeIcon
              size={iconSize ? iconSize : "1x"}
              icon={faTriangleExclamation}
              color={theme.palette["warning"].main}
            />
          </StyledIconButton>
        </Tooltip>
      )
    case TooltipInfoEnum.Parked:
      return (
        <Tooltip title={label ? label : t("global.suspended", "Suspended")}>
          <StyledIconButton color="primary" size="small">
            <FontAwesomeIcon
              size={iconSize ? iconSize : "1x"}
              icon={faSquareParking}
              color={(theme.palette as any).blue[700]}
            />
          </StyledIconButton>
        </Tooltip>
      )
    case TooltipInfoEnum.ActiveUser:
      return (
        <Tooltip title={label ? label : t("global.active_user", "Active user")}>
          <StyledIconButton color="primary" size="small">
            <FontAwesomeIcon
              size={iconSize ? iconSize : "1x"}
              icon={faUser}
              color={theme.palette["primary"].main}
            />
          </StyledIconButton>
        </Tooltip>
      )
    case TooltipInfoEnum.InActiveUser:
      return (
        <Tooltip title={label ? label : t("global.inactive_user", "Inactive user")}>
          <StyledIconButton color="info" size="small">
            <FontAwesomeIcon
              size={iconSize ? iconSize : "1x"}
              icon={faUserSlash}
              color={theme.palette["info"].main}
            />
          </StyledIconButton>
        </Tooltip>
      )
    case TooltipInfoEnum.Info:
      return (
        <Tooltip title={label ? label : t("global.information", "Information")}>
          <StyledIconButton color="primary" size="small">
            <FontAwesomeIcon
              size={iconSize ? iconSize : "1x"}
              icon={faCircleInfo}
              color={theme.palette["primary"].main}
            />
          </StyledIconButton>
        </Tooltip>
      )
    case TooltipInfoEnum.Waiting:
      return (
        <Tooltip title={label ? label : t("vehicleregistry.waiting_for_ts", "Waiting for TS")}>
          <StyledIconButton color="info" size="small" sx={{ marginLeft: "2px" }}>
            <FontAwesomeIcon
              size={iconSize ? iconSize : "1x"}
              icon={faHourglassStart}
              color={theme.palette["info"].main}
            />
          </StyledIconButton>
        </Tooltip>
      )

    default:
      return (
        <Tooltip title={label ? label : ""}>
          <StyledIconButton color={color} size="small">
            <FontAwesomeIcon
              size={iconSize ? iconSize : "1x"}
              icon={icon ? icon : faDotCircle}
              color={theme.palette[color ? color : "primary"].main}
            />
          </StyledIconButton>
        </Tooltip>
      )
  }
}

export default TooltipInfoIcon
